import $ from "jquery";

class Form {
    constructor() {
        this.choices = document.getElementById('requests');

        this.input = {
            choice: document.querySelector('.wpcf7-form input[name="choice"]'),
        }
    }
    
    run() {
        if(this.input.choice) {this.select();}
    }

    select(){
        var choice = this.input.choice.value;

        if (choice == 'cloud'){
            this.selectOption(this.choices.options[1])
            // this.choices.options[1].setAttribute('selected','selected');
        } else if (choice == 'custom') {
            this.selectOption(this.choices.options[2])
            // this.choices.options[2].setAttribute('selected','selected');
        } else if (choice == 'partner_program'){
            this.selectOption(this.choices.options[4])
            // this.choices.options[4].setAttribute('selected','selected');
        } else if (choice == 'candidate'){
            this.selectOption(this.choices.options[5])
            // this.choices.options[5].setAttribute('selected','selected');
        } 
    }   
    
    selectOption(option){
        $(option).prop('selected',false);
        $(option).removeAttr('selected');
        $(option).prop('selected',true);
        $(option).attr('selected','selected');
        $(option).change();
    }
}

const form = new Form();
export default form;